'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { LayoutContainer } from '../../kit';
import { PriceEstimator } from '../../components';
import { useBooking } from '../bookingContext';
import { useTranslation } from '../../kit/useTranslation';

export default function EstimatePage() {
  const router = useRouter();
  const { setDetails } = useBooking();
  const isLoggedIn = useSelector((s) => s.auth.isLoggedIn);
  const { t } = useTranslation();

  const onBookConsignment = useCallback(
    (bookingData) => {
      setDetails(bookingData);
      // If logged in, go to summary; otherwise, go to login with redirect param
      if (isLoggedIn) router.push('/summary');
      else router.push('/login?redirect=/summary');
    },
    [isLoggedIn, router, setDetails]
  );

  return (
    <LayoutContainer>
      <Box sx={{ mt: 2 }}>
        <PriceEstimator onBookConsignment={onBookConsignment} />
      </Box>
    </LayoutContainer>
  );
}
